import { enableProdMode, ApplicationRef } from '@angular/core';
import { createNewHosts } from '@angularclass/hmr';

export function hmrBootstrap(module: any, bootstrap: () => Promise<any>) {
  let appRef: ApplicationRef;
  module.hot.accept();

  bootstrap()
    .then(ref => (appRef = ref))
    .catch(err => console.error(err));

  module.hot.dispose(() => {
    const elements = appRef.components.map(c => c.location.nativeElement);
    const makeVisible = createNewHosts(elements);
    appRef.destroy();
    makeVisible();
  });
}
